export const ACTIONS = {
  mcoach: {
    value: 'mcoach',
    label: 'Open M:Coach Pop-up'
  },
  skillBites: {
    value: 'skillbites',
    label: 'Redirect to Skill Bites'
  },
  quizzes: {
    value: 'quizzes',
    label: 'Redirect to Quizzes'
  },
  playlists: {
    value: 'playlists',
    label: 'Redirect to Playlists'
  },
  bonus: {
    value: 'bonus',
    label: 'Redirect to Bonus Material'
  },
  explore: {
    value: 'explore',
    label: 'Open Explore Menu'
  }
}

export const BANNER_STYLES = {
  default: {
    value: 'default',
    label: 'Standard Layout'
  },
  reversed: {
    value: 'reversed',
    label: 'Reversed Layout'
  }
}

export const getOrdinalSuffix = (num) => {
  if (num >= 11 && num <= 13) return 'th'
  switch (num % 10) {
    case 1: return 'st'
    case 2: return 'nd'
    case 3: return 'rd'
    default: return 'th'
  }
}
